/* eslint-disable no-console */
<template>
<div>
    <div class="card z-depth-5 p-3">
        <h4 class="text-center font-weight-bold py-3">Add Admin</h4>
        <div>
            <!-- Default form login -->
            <form class="border border-light p-5">
                <div class="row">
                    <div class="form-group col-md-6">
                        <label>Username</label>
                        <input ref="username" class="form-control mb-4" placeholder="Username">
                    </div>
                    <div class="form-group col-md-6">
                        <label>Password</label>
                        <input type="password" ref="password" class="form-control mb-4" placeholder="Password">
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-md-12">
                        <label>Permissions</label>
                        <multiselect v-model="permissions" tag-placeholder="" placeholder="Search a tag" label="name" track-by="code" :options="permissionList" :multiple="true" :taggable="true"></multiselect>
                    </div>
                </div>
                <!-- Sign in button -->
                <button class="btn btn-info btn-block my-4" @click.prevent="addAdmin()">Add Account</button>

            </form>
            <!-- Default form login -->
        </div>
    </div>
</div>
</template>

<script>
import axios from "axios"
import Multiselect from 'vue-multiselect'


export default {
    name: 'AddAdmin',
    components: {
        Multiselect
    },
    data() {
        return {
            fastAdminToken : localStorage.getItem("fastAdminToken"),
            permissions: [
            ],
            permissionList: [
                { name: 'Message', code: 'Message' },
                { name: 'Levels', code: 'Levels' },
                { name: 'Groups', code: 'Groups' },
                { name: 'Plans', code: 'Plans' },
                { name: 'Teachers', code: 'Teachers' },
                { name: 'Admins', code: 'Admins' },
                { name: 'Students', code: 'Students' },
                { name: 'Pending Students', code: 'PendingStudents' },
                { name: 'Transactions', code: 'Transactions' },
                { name: 'Homeworks', code: 'Homeworks' },
                { name: 'Report', code: 'Report' },
            ]
        }
    },
    methods: {
        addAdmin() {
            if (
                this.$refs.username.value == '' ||
                this.$refs.password.value == '') {
                this.$toast.open({
                    message: "ERROR : All Fields Are Required",
                    type: 'error'
                })
            } else {

                let permissions = [];

                for (var i in this.permissions) {
                    permissions.push(this.permissions[i].name);
                }

                let data = {
                    username: this.$refs.username.value,
                    password: this.$refs.password.value,
                    permissions: permissions
                }

                const config = {
                    headers: {
                        Authorization: "Bearer " + this.fastAdminToken,
                        'Content-Type': 'application/json'
                    }
                }
                this.$toast.open({
                    message: "Processing : Creating Admin Please Wait...",
                    type: 'info'
                })
                axios.post(this.$apiURI + "/auth/register/admin", data, config)

                    .then((response) => {
                        if (response.data.error) {
                            this.$toast.open({
                                message: "Error : " + response.data.message,
                                type: 'error'
                            });
                        } else {
                            this.$toast.open({
                                message: "Admin Created Successfully",
                                type: 'success'
                            })
                        }

                    }).catch((error) => {
                        this.$toast.open({
                            message: "Error : " + error.response.data.message,
                            type: 'error'
                        });
                    })
            }
        }
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
